import { useMemo } from 'react';
import { useHeaderMenuContext } from '@/creditflowresearch/application/HeaderMenu/HeaderMenuContext';
import { useScorecardState } from '@/creditflowresearch/application/League/Scorecard/hooks/useScorecardState';
import { useScorecardApi } from '@/creditflowresearch/application/League/Scorecard/hooks/useScorecardApi';
import { IScorecardProps } from '@/creditflowresearch/application/League/Scorecard/types';

export const useScorecardDependencies = (props: IScorecardProps) => {
  const { products, regions } = useHeaderMenuContext();
  const { state, ...stateActions } = useScorecardState(props);
  const { getCompany, getStandings } = useScorecardApi(stateActions);

  const data = useMemo(() => state.data, [state.data]);
  const periods = useMemo(() => data?.periods || [], [data?.periods]);
  const type = useMemo(() => data?.type || '', [data?.type]);

  return useMemo(() => ({
    state,
    stateActions,
    periods,
    type,
    getCompany,
    getStandings,
    productsList: products,
    regionsList: regions,
  }), [
    state,
    stateActions,
    periods,
    type,
    getCompany,
    getStandings,
    products,
    regions,
  ]);
};
